import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import Pager from "@/components/site/Pager";
import Reveal from "@/components/site/Reveal";
import { api } from "@/lib/api";
import { useSEO } from "@/lib/seo";

const PAGE_SIZE = 9;

export default function Testimonials() {
  useSEO({
    title: "Testimonials",
    description: "Hear from pharma leaders and candidates about partnering with PharmacoHires.",
    pageKey: "testimonials",
  });
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    api.get("/testimonials", { params: { page, page_size: PAGE_SIZE } }).then((r) => {
      const d = r.data || {};
      setItems(Array.isArray(d.items) ? d.items : []);
      setTotal(Number(d.total) || 0);
    }).catch(() => { setItems([]); setTotal(0); });
  }, [page]);

  return (
    <>
      <PageHero
        overline="Testimonials"
        title="Words from the people we've worked with."
        description="A handful of stories from pharma leaders and the candidates we've helped place."
      />
      <section className="section-pad bg-slate-50">
        <div className="container-page">
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {items.map((t, idx) => (
              <Reveal key={t.id} variant="up" delay={Math.min(idx * 80, 320)}>
                <div className="h-full rounded-xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md" data-testid={`testimonial-${t.id}`}>
                  <div className="flex items-center gap-1 text-secondary">
                    {Array.from({ length: t.rating || 5 }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-secondary" />
                    ))}
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-slate-700">“{t.content}”</p>
                  <div className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4">
                    <div className="grid h-10 w-10 place-items-center rounded-full bg-primary/10 font-semibold text-primary">{t.name?.charAt(0)}</div>
                    <div>
                      <div className="font-semibold text-slate-900">{t.name}</div>
                      <div className="text-xs text-slate-500">{t.role}{t.role && t.company ? " · " : ""}{t.company}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
            {items.length === 0 && (
              <div className="col-span-full rounded-xl border border-dashed border-slate-300 p-12 text-center text-slate-500">No testimonials yet.</div>
            )}
          </div>
          <Pager page={page} pageSize={PAGE_SIZE} total={total} onChange={setPage} testIdPrefix="testimonials-pager" />
        </div>
      </section>
    </>
  );
}
